import '../styles/styles.scss';

import initJS from '../../../js/init';
import { AppIdentifierEnum, SiteLevel2Enum } from '@hmg/data-layer-api-specification-node';

initJS({ appIdentifier: AppIdentifierEnum.wp_offerpage, siteLevel2: SiteLevel2Enum.ww_web });

